import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

let WIDTH =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

let HEIGHT =
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;

function handleDefaultWidth(position) {
  switch(position) {
    case 'LEFT':
      return isMobile ? WIDTH : (WIDTH * 2) / 3
    case 'RIGHT':
      return isMobile ? WIDTH : WIDTH / 3
    default:
      // do nothing
  }
}

function handleDefaultHeight(position) {
  switch(position) {
    case 'TOP':
      return isMobile ? (HEIGHT * 3) / 5 : HEIGHT
    case 'BOTTOM':
      return isMobile ? (HEIGHT * 2) / 5 : HEIGHT
    default:
      // do nothing
  }
}

console.log(isMobile)

export default function useWindowResizing() {
  const [widthLeft, setWidthLeft] = useState(() => handleDefaultWidth('LEFT'));
  const [widthRight, setWidthRight] = useState(() => handleDefaultWidth('RIGHT'));

  const [heightTop, setHeightTop] = useState(() => handleDefaultHeight('TOP'));
  const [heightBottom, setHeightBottom] = useState(() => handleDefaultHeight('BOTTOM'));

  function onResizeLeft(_, { size }) {
    setWidthLeft(size.width);
    setWidthRight(WIDTH - size.width);
  }

  function onResizeRight(_, { size }) {
    setWidthRight(size.width);
  }

  useEffect(() => {
    setWidthLeft(handleDefaultWidth('LEFT'))
    setWidthRight(handleDefaultWidth('RIGHT'))
    setHeightTop(handleDefaultHeight('TOP'))
    setHeightBottom(handleDefaultHeight('BOTTOM'))

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile])

  return {widthLeft, widthRight, onResizeLeft, onResizeRight, heightTop, heightBottom, isMobile, WIDTH, HEIGHT}
}
